<script setup lang="ts">
import { TrackItMeasurementParameterDto } from '@/api/generator';
import KeyValueTable from '@/components/KeyValueTable/KeyValueTable.vue';
import { formatMeasurementParameterValue } from '@/views/tasks/components/trackItFilters';
import { computed } from 'vue';

const props = defineProps<{
  title: string;
  parameters: TrackItMeasurementParameterDto[];
}>();

const rows = computed(() =>
  props.parameters.map((parameter) => ({
    label: parameter.name ?? '',
    value: formatMeasurementParameterValue(parameter),
  })),
);
</script>

<template>
  <div>
    <h5>{{ title }}</h5>
    <KeyValueTable :rows="rows" />
  </div>
</template>
